var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:(_vm.styles),attrs:{"width":_vm.sizeValue,"height":_vm.sizeValue,"viewBox":_vm.viewboxValue}},[_c('path',{attrs:{"d":_vm.path}})])}
var staticRenderFns = []

export { render, staticRenderFns }